module.exports = __webpack_public_path__ + "img/custom_page_layout2.ace475e4.png";